module.exports = "https://r.zoocdn.com/_next/static/images/for-sale-property-cluster-pin-d069d6c9cae5c9df5285aa2c8d09dd01.svg";